<template>
  <div>
    <!-- 问题 -->
    <el-row>
      <el-col>
        <el-row class="q-area">
          <el-col v-if="question!=null && question.type==1" :span="6"></el-col>
          <el-col v-if="question!=null && question.type==1" :span="9">
            <p class="title" :style="{fontSize: (question!=null?question.questionWord.content1:'').length<10?'50px':(question!=null?question.questionWord.content1:'').length<25?'40px':'25px'}">{{question!=null?question.questionWord.content1:''}}</p>
          </el-col>
          <el-col v-if="question!=null && question.type==1" :span="1">
            <i class="title-play el-icon-video-play" v-if="question!=null" @click="playAudio(question.questionWord.content7)"></i>
          </el-col>
          <el-col v-if="question!=null && question.type==2" :span="21" :offset="2">
            <i v-if="question!=null" @click="playAudio(question.questionWord.content7)" class="el-icon-video-play play-title"></i>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- 选项 -->
    <el-row>
      <el-col v-if="question!=null && (question.type==1 || question.type==2)" :span="24">
        <el-button @click="clickOpt(question!=null?question.optionA:'')">
          <p :style="{color: borderShow?optionColor(question!=null?question.optionA:''):'#000000'}">
            A: {{question!=null?question.optionA:''}}
          </p>
        </el-button>
      </el-col>
      <el-col v-if="question!=null && (question.type==1 || question.type==2)" :span="24">
        <el-button @click="clickOpt(question!=null?question.optionB:'')">
          <p :style="{color: borderShow?optionColor(question!=null?question.optionB:''):'#000000'}">
            B: {{question!=null?question.optionB:''}}
          </p>
        </el-button>
      </el-col>
      <el-col v-if="question!=null && (question.type==1 || question.type==2)" :span="24">
        <el-button @click="clickOpt(question!=null?question.optionC:'')">
          <p :style="{color: borderShow?optionColor(question!=null?question.optionC:''):'#000000'}">
            C: {{question!=null?question.optionC:''}}
          </p>
        </el-button>
      </el-col>
      <el-col v-if="question!=null && (question.type==1 || question.type==2)" :span="24">
        <el-button @click="clickOpt(question!=null?question.optionD:'')">
          <p :style="{color: borderShow?optionColor(question!=null?question.optionD:''):'#000000'}">
            D: {{question!=null?question.optionD:''}}
          </p>
        </el-button>
      </el-col>
      <!-- 输入框 -->
      <el-col v-if="question!=null && question.type==3" class="input-area" :span="12" :offset="7">
        <el-row>
          <el-col :span="22">
            <i style="font-size: 80px;margin:  0px 100px 71px 0;color: #334970ee" v-if="question!=null" @click="playAudio(question.questionWord.content7)" class="el-icon-video-play"></i>
          </el-col>
          <el-col :span="11">
            <input type="text" style="float: left" placeholder="拼写出你听到的单词" v-model="writeInput" class="text-input" @keydown.enter="clickOpt(writeInput!=null?writeInput:'')">
          </el-col>
          <el-col :span="2" :offset="9">
            <el-button 
            type="primary" 
            style="color: #fff;margin: 0 0 0 0;float: right; width: 120px; height: 60px; border-radius: 0 40px 40px 0; font-size: 25px; background-color: #334970ee"
            @click="clickOpt(writeInput!=null?writeInput:'')">
              确认
            </el-button>
          </el-col>
          <el-col :span="19">
            <p v-if="borderShow" :style="{fontSize: '2em',color: optionColor(writeInput)}">{{question.questionWord.content1}}</p>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  props: ['question'],
  watch: {
    question: function(n) {
      this.playAudio(n.questionWord.content7)
    }
  },
  data() {
    return {
      clicked: false,
      clickOption: '',
      borderShow: false,
      writeInput: '',
    }
  },
  methods: {
    playAudio(url) {
      let audio = new Audio()
      audio.src = `https://awesome-platform.oss-cn-shanghai.aliyuncs.com/quick/v${url}`
      audio.play();
    },
    clickOpt( option ) {
      if (!this.clicked) {
        this.clicked = true;
        this.clickOption = option;
        this.borderShow = true;
        setTimeout(()=>{
          this.question.answer = option;
          this.clicked = false;
          this.borderShow = false;
          this.writeInput = '';
          this.$emit('nextQuestion',this.question)
        },2000)
      }
    },
    optionColor(option) {
      if (this.question.type != 3) {
        if (option == this.clickOption) {
          if (option == this.question.questionWord.content3) {
            return '#5DBF39'
          } else {
            return '#BF3939'
          }
        } else {
          if (option == this.question.questionWord.content3) {
            return '#5DBF39'
          } else {
            return '#000000'
          }
        }
      } else {
        if (option.trim().toLowerCase() == this.question.questionWord.content1.trim().toLowerCase()) {
          return '#5DBF39'
        } else {
          return '#BF3939'
        }
      }
    }
  }
}
</script>
<style scoped>
.q-area{
  display: flex;
  flex-direction: row;
  justify-items: center;
  align-content: center;
  margin-left: 3%;
}
.title{
  font-size: 50px;
  margin:  90px 0;
  width: 90%;
  word-wrap: break-word; 
  word-break: normal;
}
.title-play{
  font-size: 50px;
  margin:  100px 0px 0 0;
  color: #334970ee
}
.play-title {
  font-size: 80px;
  margin:  100px 100px 71px 0;
  color: #334970ee;
}
.input-area{
  margin-top: 200px;
}
.el-button{
  margin: 15px 0;
  width: 700px;
  height: 80px;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #FFF;
  border: 1px solid #DCDFE6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  -webkit-transition: .1s;
  transition: .1s;
  font-weight: 500;
  padding: 12px 20px;
  font-size: 18px;
  border-radius: 40px;
}
.el-button:hover, .el-button:focus{
  background: #FFF
}
.text-input{
  z-index: 1;
  width: 660px;
  height: 60px;
  text-rendering: auto;
  color: -internal-light-dark-color(black, white);
  letter-spacing: normal;
  word-spacing: normal;
  text-transform: none;
  text-indent: 20px;
  text-shadow: none;
  display: inline-block;
  text-align: start;
  -webkit-appearance: textfield;
  background-color: -internal-light-dark-color(white, black);
  -webkit-rtl-ordering: logical;
  cursor: text;
  margin: 0;
  font: 300 35px Arial;
  padding: 0px 0px;
  border-width: 0px;
  border-color: transparent;
  border-image: initial;
  border-radius: 40px 0 0 40px;
  outline: none;
}
::-webkit-input-placeholder { /* WebKit browsers */
  color: #888;
  font: 100 0.8em sans-serif;
}

::-moz-placeholder { /* Mozilla Firefox 19+ */
  color: #888;
  font: 100 0.8em sans-serif;
}

:-ms-input-placeholder { /* Internet Explorer 10+ */
  color: #888;
  font: 100 0.8em sans-serif;
}
@media screen and (max-width: 1400px){
  .title{
    font-size: 50px;
    margin:  40px 0;
  }
  .title-play{
    font-size: 40px;
    margin:  55px 0px 0 0;
  }
  .play-title {
    font-size: 80px;
    margin:  40px 100px 40px 0;
    color: #334970ee;
  }
  .text-input{
    width: 400px;
  }
  .input-area{
    margin-top: 100px;
  }
}
</style>